import Login from '@zhenguo/vue-jssdk/vue-plugins/login'

export default function (data = {}) {
  return function (app) {
    for (const key of Object.keys(data)) {
      app.prototype['$' + key] = data[key]
    }
    app.use(Login)
  }
}
